module.exports = "/images/img-1.png?a444f36f55338b2bbb8f0fe46b9724ce";